// removed by extract-text-webpack-plugin
module.exports = {"classKeyFacts":"KeyFacts-classKeyFacts-ab25fb80"};


//////////////////
// WEBPACK FOOTER
// ./src/themes/defaults/sass/components/KeyFacts.scss
// module id = 869
// module chunks = 0